import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c12d55a")

_pushScopeId("data-v-3c12d55a")
const _hoisted_1 = { class: "white-back-mask" }
const _hoisted_2 = { class: "wechat-verification-content" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "info-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountManageHeader = _resolveComponent("AccountManageHeader")!
  const _component_VerificationHeader = _resolveComponent("VerificationHeader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AccountManageHeader, { onClose: _ctx.closeModal }, null, 8, ["onClose"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_VerificationHeader),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: _ctx.loginTypeInfo.icon,
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_6, [
              _createVNode("p", null, "验证绑定的" + _toDisplayString(_ctx.loginTypeInfo.text), 1),
              _createVNode("p", null, _toDisplayString(_ctx.nickname), 1)
            ])
          ]),
          _createVNode("div", {
            class: "right",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, "立即验证")
        ])
      ])
    ])
  ]))
})